import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, tap } from 'rxjs';
import { IParams } from '../model/http';

export const initUsersParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};

export interface IUsersApiResponse {
  items?: any[];
  total?: number;
  size?: number;
  page?: number;
}

@Injectable({
  providedIn: 'root'
})
export class TelegramService {
  constructor(
    private readonly http: HttpClient,
  ) { }
  private readonly usersSubject$ = new BehaviorSubject<any>({});
  public readonly users$ = this.usersSubject$.asObservable();

  public readonly isLoader$ = new BehaviorSubject<boolean>(false);

  public queryUsersParams = { ...initUsersParams };


  private getAll(params: any) {
    return this.http.get<any>(environment.baseURL + '/tg/users/', { params })
      .pipe(map(v => v.data));
  }

  loadUsers() {
    this.isLoader$.next(true);
    return this.getAll(this.queryUsersParams)
      .pipe(tap((users) => {
        this.usersSubject$.next(users);
        this.isLoader$.next(false);
      }));
  }

  setQueryUsersParams(params: IParams) {
    const { sort, order, search, take, page } = params;
    this.queryUsersParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryUsersParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryUsersParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryUsersParams.search,
      take: take || this.queryUsersParams.take,
      page: page || this.queryUsersParams.page,
    };
    return this.loadUsers();
  }


  addPhone(phone: string) {
    return this.http.post(environment.baseURL + '/tg/user/', { phone });
  }

  removePhone(id: string) {
    return this.http.delete(environment.baseURL + `/tg/user/${id}`);
  }

  assignUser(id: string, user_id: string | null) {
    return this.http.patch(environment.baseURL + `/tg/user/${id}`, { user_id });
  }
}
